import {Map} from 'immutable';

import * as actions from './actions';


export default function reducer(state, action) {
    if (!state.get('selected'))
        state = state.set('selected', new Map());
    if (state.get('elementId') === action.elementId) {
        // switch (action.type) {
        // case actions.TOGGLE_QUESTION_SELECTION:
        //     const id = String(action.payload.id);
        //     if (state.get('selected').get(id)) {
        //         state = state.removeIn(
        //                 ['selected', id],
        //             );
        //     }
        //     else {
        //         state = state.setIn(
        //                 ['selected', id],
        //                 action.payload,
        //             );
        //     }
        //     break;

        // case actions.CLEAR_QUESTION_SELECTION:
        //     state = state.set('selected', new Map());
        // }
    }
    return state;
}
